"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOT_FOUND = exports.UNHANDLED = exports.INVALID_PARAMETER = exports.INVALID_ZIPCODE = exports.INVALID_PHONE_NUMBER = exports.INVALID_PASSWORD = exports.INVALID_NAME = exports.INVALID_EMAIL = exports.WORKER_CREATION_FAILED = exports.NOT_ATTORNEY = exports.ATTORNEY_CREATION_FAILED = exports.UNAUTHORIZED_DISQUALIFIED_FILER = exports.FILER_CREATION_FAILED = exports.LOGIN_FAILED = void 0; // Accounts
// - auth
// The following error code is used for all authentication failures (login, password reset, etc.)
// to prevent user enumeration attacks. Do not use codes that reveal whether an account exists or not.
// See: https://cheatsheetseries.owasp.org/cheatsheets/Authentication_Cheat_Sheet.html#authentication-and-error-messages
// See: https://pages.nist.gov/800-63-3/sp800-63b.html (Section 5.1.2)

exports.LOGIN_FAILED = "loginFailed"; // - filer

exports.FILER_CREATION_FAILED = "filerCreationFailed";
exports.UNAUTHORIZED_DISQUALIFIED_FILER = "unauthorizedDisqualifiedFiler"; // - attorney

exports.ATTORNEY_CREATION_FAILED = "attorneyCreationFailed";
exports.NOT_ATTORNEY = "notAttorney"; // - worker

exports.WORKER_CREATION_FAILED = "workerCreationFailed"; // Validation

exports.INVALID_EMAIL = "invalidEmail";
exports.INVALID_NAME = "invalidName";
exports.INVALID_PASSWORD = "invalidPassword";
exports.INVALID_PHONE_NUMBER = "invalidPhoneNumber";
exports.INVALID_ZIPCODE = "invalidZipcode"; // Parameters

exports.INVALID_PARAMETER = "invalidParameter"; // Misc

exports.UNHANDLED = "unhandled";
exports.NOT_FOUND = "notFound";